import { useAppContext } from '@/App.context'

import './button.scss'

const Button = ({ children, className = '', disabled = false, ...restOfProps }: any) => {
  const { whiteLabel } = useAppContext()

  return (
    <button
      className={`std-button ${whiteLabel} ${className}`}
      {...restOfProps}
      disabled={disabled}
    >
      {children}
    </button>
  )
}

export default Button
